<div class="text-divider" (click)="toggleOpened()" [ngStyle]="{'margin': '5px 0px', 'cursor': clickable ? 'pointer' : 'default'}">
  <span class="text"><ng-content></ng-content></span>
  @if (clickable) {
    <mat-icon style="margin-right: 5px;">
      {{ opened ? 'arrow_circle_up' : 'arrow_circle_down' }}
    </mat-icon>
  }
  <mat-divider class="line"></mat-divider>
</div>
